import { createSelector, createStructuredSelector } from "reselect";
import { initialState, State as DashboardState } from "./redux";
import {
  selectTnCForCidpUser,
  selectHasUserAcceptedTnC,
} from "scenes/selectors";

/**
 * Direct selector to the dashboard state domain
 */

const selectDashboardDomain: (any) => DashboardState = (state) =>
  state.dashboardRoot || initialState;

/**
 * Custom selectors to the dashboard state
 */
export const selectDashboard = createSelector(
  selectDashboardDomain,
  (substate) => substate
);

/**
 * Multi instance selectors exporting a factory
 */
export const makeSelectDashboard = () =>
  createSelector(selectDashboardDomain, (substate) => substate);

// add structured selectors here, which will be mapped as prop to scene component
export default createStructuredSelector({
  updatedTnC: selectTnCForCidpUser,
  hasUpdatedTnCAccepted: selectHasUserAcceptedTnC,
  tncForCidpUser: selectTnCForCidpUser,
});
